import { LOGO } from '@/shared/brand';
import { cn } from '@/lib/utils';

/** The Ghost Cable logo mark. Decorative next to the name, so alt is empty unless `label` is set. */
export default function BrandLogo({ size = 28, label, className }) {
  return (
    <img
      src={LOGO.mark}
      width={size}
      height={size}
      alt={label ?? ''}
      decoding="async"
      draggable={false}
      className={cn('shrink-0 select-none object-contain', className)}
      style={{ width: size, height: size }}
    />
  );
}
